import React from 'react';

import { textContent, paperCategory, newsCategory, experienceCategory } from '../../../types/data.global';

import MyPanel from '../../MyPanel';

import { Row, Col, Tabs } from 'antd';
import { TabsProps } from 'antd';
import { Avatar, List } from 'antd';
import _ from 'lodash';

const TeachingAndContactSection: React.FC = () => { 

  

  const experienceElementListTest = textContent.experiencePage.map(experienceInfo => {
    const conrseList = experienceInfo.courseList.map(courseObj => {
      return (
        <div className='course-unit-div' style={{marginBottom: (courseObj.courseDescription === '') ? 0 : 12}}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='institution'>
              {courseObj.courseName}
            </div>
            <div className='year' style={{ textAlign: 'right', minWidth: 60 }}>
              {courseObj.courseYear}
            </div>
          </div>
          <div className='course-description' style={{fontSize: 15, color: '#666', marginLeft: 12}}>{courseObj.courseDescription}</div>
        </div>
      )
    })
    return (
      <div className='experience-unit-div' style={{width: '100%'}}>
        <div className='text-info' style={{width: '100%'}}>
          <div className='role'>
            <span>{experienceInfo.role}</span>
          </div>
          {conrseList}
        </div>
      </div>
    )
  })

  return (
    <div className='page-div' style={{width: '100%', paddingTop: 32}} id='teachingPage'>
      <Row justify="space-between" style={{width: '100%'}} className='page-div'>
        <Col xs={24} sm={24} md={22} lg={22} className='left-div'>
          <MyPanel viewTitle="Teaching" width={''} height={'auto'} panelHeaderHeight={72}>
            <div style={{padding: 16}} >
              {experienceElementListTest}
            </div>
          </MyPanel>
        </Col>
        {/* <Col xs={24} sm={24} md={8} lg={8} className='left-div'>
          <MyPanel viewTitle="FOR MORE INFORMATION" width={''} height={'auto'} panelHeaderHeight={72}>
            <div className='contact-div' id='contactPage'>
              <List
                itemLayout="horizontal"
                dataSource={textContent.contactPage}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar src={item.platformLogo} shape="square" />}
                      title={item.platform}
                      description={<a href={item.link}>{item.content}</a>}
                    />
                  </List.Item>
                )}
              />
            </div>
          </MyPanel>
        </Col> */}
      </Row>
    </div>
  )
};

export default TeachingAndContactSection;